import { render } from "./ThePatientConsultationScroll.vue?vue&type=template&id=54d35871&scoped=true&ts=true"
import script from "./ThePatientConsultationScroll.vue?vue&type=script&lang=ts"
export * from "./ThePatientConsultationScroll.vue?vue&type=script&lang=ts"

import "./ThePatientConsultationScroll.vue?vue&type=style&index=0&id=54d35871&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d35871"]])

export default __exports__